import * as Yup from 'yup';
import { useState, useContext, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { mask } from "remask";
import NumberFormat from 'react-number-format';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


// material
import { Stack, TextField, Alert, Autocomplete} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';

import Theme from '../../../components/Button';

import {api, reiniciarToken, cadastrarDespesas,  consultaTipoDespesas} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';

// ----------------------------------------------------------------------

export default function CadDespesaForm() {

  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [tipoDespesas, setListTipoDespesas] = useState([]);

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    id_tipo_despesa: Yup.string().required('Tipo de Despesa é obrigatório'),
    data_pagamento: Yup.string().required('Data do Pagamento é obrigatório'),
    valor_pagamento: Yup.string().required('Valor do Pagamento é obrigatório'),
  });

  const formik = useFormik({
   initialValues: {
        descricao: '',
        data_pagamento: Date.now(),
        valor_pagamento: '',
        id_tipo_despesa: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const handleSubmit = async e => {
    e.preventDefault();

    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const json = {descricao: formik.values.descricao,
                  data_pagamento: formik.values.data_pagamento,
                  valor_pagamento: formik.values.valor_pagamento,
                  id_tipo_despesa: formik.values.id_tipo_despesa,
                  usuario: localStorage.getItem(['usuario']),
                  id_empresa: localStorage.getItem(['id_empresa'])};

    const response = await cadastrarDespesas(json);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    }; 
  }

  const getListas = async () => {

    const response = await consultaTipoDespesas();

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setListTipoDespesas(tipoDespesas => [...tipoDespesas, {id_tipo_despesa: valores.id_tipo_despesa, descricao: valores.descricao}])
      }); 
    };
  }

  useEffect(() => {
    
    const renovarToken = async () => {
      const retorno = await reiniciarToken();
      if(retorno.erro === true) {
        if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
          logout();
        }
      }else{
        localStorage.setItem("token", retorno.data.token);
        api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
      }
    };

    renovarToken();
    getListas();

  },[]);

  const { errors, touched, isSubmitting, getFieldProps, handleBlur, handleChange, setFieldValue} = formik;
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Autocomplete
                getOptionLabel={(resultado) => resultado.descricao}
                options={tipoDespesas}
                fullWidth
                onChange={(e, value) => { 
                  setFieldValue('id_tipo_despesa', value?.id_tipo_despesa, false) 
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Tipo Despesa" 
                                            fullWidth
                                            {...getFieldProps('id_tipo_despesa')}
                                            error={Boolean(touched.id_tipo_despesa && errors.id_tipo_despesa)}
                                            helperText={touched.id_tipo_despesa && errors.id_tipo_despesa}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={formik.values?.id_tipo_despesa}
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => option.id_tipo_despesa === value.id_tipo_despesa}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
              <DatePicker
                label="Data Pagamento"
                value={formik.values?.data_pagamento}
                onChange={(newValue) => {
                  setFieldValue('data_pagamento', newValue, false); 
                }}
                renderInput={(params) => <TextField {...params} fullWidth/>}
            />
            </LocalizationProvider>
            <NumberFormat
              fullWidth
              label="Valor do Pagamento"
              {...getFieldProps('valor_pagamento')}
              error={Boolean(touched.valor_pagamento && errors.valor_pagamento)}
              helperText={touched.valor_pagamento && errors.valor_pagamento}
              customInput={TextField}
              decimalSeparator={','}
            />
          </Stack>
          
          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Cadastrar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
